module.exports = __webpack_public_path__ + "img/img7.439ea0f3.svg";